import React from 'react';
import {MyDataGrid, MyIconButton} from '../../common/components';
import { IconPencil, IconTrash } from '@tabler/icons';
import {
    Chip,
    Stack,
} from '@mui/material';
import { capitalize } from 'lodash';

const columns = [
    {
        field: 'question',
        headerName: 'Question',
        sortable: true,
        width: 500,
        valueGetter: (params) => {
            return params.row.question;
        },
    },
    
    {
        field: 'actions',
        headerName: 'Actions',
        sortable: false,
        width: 150,
        renderCell: (params) => {
            return  (
                <Stack direction="row" spacing={1}>
                    {
                        (
                            params.row.actions.onEdit
                            && typeof params.row.actions.onEdit === 'function'
                        ) &&
                        <MyIconButton
                            label="Edit Question"
                            onClick={(e) => {
                                e.stopPropagation();
                                params.row.actions.onEdit(params.row);
                            }}>
                            <IconPencil />
                        </MyIconButton>
                    }
                    {
                        (
                            params.row.actions.onDelete
                            && typeof params.row.actions.onDelete === 'function'
                        ) &&
                        <MyIconButton
                            label="Delete Question"
                            onClick={(e) => {
                                e.stopPropagation();
                                params.row.actions.onDelete(params.row.uuid);
                            }}>
                            <IconTrash />
                        </MyIconButton>
                    }
                </Stack>
            );
        }
    },
];

export default function ManageQuestionsTable({data, loading, onAdd, showToolbar=true}) {
    return (
        <MyDataGrid
            onAdd={onAdd}
            loading={loading}
            data={data}
            columns={columns}
            showToolbar={showToolbar}
            getRowId={(row) => {
                return row.id;
            }}
            height={100}
        />
    );
}